import React, { useState } from "react";
import { cn } from "./utils";

const TechForm = ({ comparisonTechName, onSubmit, loading, ...props }) => {
  const [techName, setTechName] = useState(comparisonTechName || "");
  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit(techName);
  };
  const handleClickSuggestion = (suggestion) => {
    setTechName(suggestion);
    onSubmit(suggestion);
  };
  return (
    <form
      onSubmit={handleSubmit}
      className={cn(
        "absolute z-20 flex flex-col items-center",
        props.className
      )}
    >
      <div className="flex items-center focus-within:ring-2 focus-within:ring-blue-500 rounded-md">
        <input
          required
          id="comparisonTech"
          name="comparisonTech"
          type="text"
          placeholder="Enter a technology..."
          disabled={loading}
          value={techName}
          onChange={(e) => setTechName(e.target.value)}
          className="px-4 py-2 h-10 border-l border-t border-b border-gray-300 rounded-l-md focus:outline-none"
        />
        <button
          type="submit"
          disabled={loading}
          className="ml-0 h-10 border-t border-r border-b border-gray-300 px-4 py-1.5 bg-blue-500 text-white font-semibold rounded-r-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-blue-300 disabled:hover:bg-blue-300"
        >
          {loading ? "Loading..." : "Explore"}
        </button>
      </div>
      {!comparisonTechName && (
        <p className="text-gray-500 text-xs mt-2">
          Hint: try{" "}
          <span
            className="font-semibold cursor-pointer hover:text-gray-700"
            onClick={() => handleClickSuggestion("Java")}
          >
            Java
          </span>
          ,{" "}
          <span
            className="font-semibold cursor-pointer hover:text-gray-700"
            onClick={() => handleClickSuggestion("React")}
          >
            React
          </span>
          ,{" "}
          <span
            className="font-semibold cursor-pointer hover:text-gray-700"
            onClick={() => handleClickSuggestion("UX Designer")}
          >
            UX Designer
          </span>
          , or{" "}
          <span
            className="font-semibold cursor-pointer hover:text-gray-700"
            onClick={() => handleClickSuggestion("LLVM")}
          >
            LLVM
          </span>
          .
        </p>
      )}
    </form>
  );
};

export default TechForm;
